import React, { useState } from "react";
import { IPageOfferListProps } from "./PageOfferListProps";
import { OfferListContainer, OfferList } from "./PageOfferListHelpers";
import OfferSearchModal from "../OfferSearchModal/OfferSearchModal";

const PageOfferList: React.FC<IPageOfferListProps> = (props) => {
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [rate, setRate] = useState({});
  const [minLOS, setMinLOS] = useState<string | null>(null);
  const [minLeadDays, setMinLeadDays] = useState<string | null>(null);
  const offers = props.offers || [];

  const handleBookNow = (event: any) => {
    const rateCode = event.target.dataset.rate;
    const offerName = event.target.dataset.offername;
    const selectedOffer = offers.find(
      (offer) => offer?.field_promo_code === rateCode
    );
    if (selectedOffer) {
      setMinLOS(selectedOffer.field_minimum_length_stay || null);
      setMinLeadDays(selectedOffer.field_lead_days || null);
    }
    setRate({
      code: rateCode,
      name: offerName,
    });
    setShowOfferModal(true);
  };
  return (
    <OfferListContainer>
      {offers.map((offer: any, i: number) => {
        return (
          <OfferList key={i} offer={offer} handleBookNow={handleBookNow} />
        );
      })}
      <OfferSearchModal
        show={showOfferModal}
        onHide={() => {
          setShowOfferModal(false);
        }}
        location={props.location}
        rate={rate}
        minLOS={minLOS}
        minLeadDays={minLeadDays}
      />
    </OfferListContainer>
  );
};

export default PageOfferList;
